<app-composite-component 
    [template_page]="pageContent" 
/>

<ng-template #pageContent>
    <page-content class="page-content" [@.disabled]="loadingPage$$()">
        <div #detailsSection class="details-section"
            [class.dragging]="dragging$$()"
            [class.no-list]="isContentLayout$$()"
            [style.height]="sectionHeight$$()"
        >
            <app-section-details-tab-layout
                (btnCancel)="emit_btnCancel()"
                (btnDelete)="emit_btnDelete()"
                (btnEdit)="emit_btnEdit()"
                (btnSave)="emit_btnSave()"
                [btnCancelData]="btnCancelData$$()"
                [btnDeleteData]="btnDeleteData$$()"
                [btnEditData]="btnEditData$$()"
                [btnSaveData]="btnSaveData$$()"
            />
        </div>
        @if (resizeHandle_show$$()) {
            <div class="resize-handle"
                (pointerdown)="emit_resizeStart($event)"
                (pointermove)="emit_resizeMove($event)"
                (pointerup)="emit_resizeEnd($event)"
                (pointercancel)="emit_resizeEnd($event)"
            ></div>
        }
        <div class="tab-section" [class.tab-inset]="tabIsPanel$$()" [@showHideVisible]="{value: (tabVisible$$()) ? 'true' : 'false', params: { enterTime: _showHideEnterTime$$(), leaveTime: _showHideLeaveTime$$() }}">
            <app-tablist-header />
            <mat-tab-group
                (touchend)="emit_touchEnd($event, 'end')"
                (touchstart)="emit_touchStart($event, 'start')"
                [class.animating]="animating$$()"
                [preserveContent]="true"
                [selectedIndex]="tabIndex$$()"
            >
                @for (item of tabList_templates$$(); track trackById(item)) {
                    <mat-tab>
                        <ng-template matTabContent>
                            <ng-container *ngTemplateOutlet="item.template" />
                        </ng-template>
                    </mat-tab>
                }
            </mat-tab-group>
        </div>
        @if (tabList_footer_templates$$()?.[tabIndex$$()]; as _footerTemplate) {
            <ng-container *ngTemplateOutlet="_footerTemplate" />
        } @else {
            <app-tab-footer />
        }
    </page-content>
</ng-template>

<ng-template #footerContentBlock>
    <buttons-group 
        [@slideTop]="pageMode$$()" 
        [class]="pageMode$$()"
    >
        @if (sectionDetails_show$$()) {
            <ng-container *ngTemplateOutlet="sectionDetails_buttons_template$$()" />
        }
        @if (sectionEdit_show$$()) {
            <ng-container *ngTemplateOutlet="sectionEdit_buttons_template$$()" />
        }
    </buttons-group>
    <buttons-group 
        [@slideBottom]="pageMode$$()" 
        [class]="pageMode$$()"
    >
        <ng-container *ngTemplateOutlet="listButtons" />
    </buttons-group>
</ng-template>

<ng-template #listButtons>
    <mat-tab-group class="buttons-block"
        [preserveContent]="true"
        [selectedIndex]="tabIndex$$()"
    >
        @for (item of tabList_buttons_template$$(); track trackById(item)) {
            <mat-tab>
                <ng-template matTabContent>
                    <ng-container *ngTemplateOutlet="item?.template" />
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</ng-template>
